import { Box, Stack } from '@mui/material';
import { Typography, colors } from '@sweep-io/sweep-design';
import { ReactNode } from 'react';

const upgradeTag = (
  <Box
    sx={{
      borderRadius: '2px',
      height: '16px',
      paddingLeft: '4px',
      paddingRight: '4px',
      display: 'flex',
      alignItems: 'center',
    }}
  >
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        backgroundColor: colors.lilac[100],
        opacity: 0.5,
        borderRadius: 'inherit',
      }}
    />
    <Box
      sx={{
        position: 'relative',
        zIndex: 1,
        fontSize: '10px',
        fontWeight: 600,
        color: colors.lilac[500],
        lineHeight: 1,
      }}
    >
      upgrade
    </Box>
  </Box>
);

interface ZeroStateActionCardProps {
  icon: ReactNode;
  name: string;
  description: string;
  onClick: () => void;
  isActive?: boolean;
  showUpgradeTag?: boolean;
}

export const ZeroStateActionCard = ({
  icon,
  name,
  description,
  onClick,
  isActive = false,
  showUpgradeTag = false,
}: ZeroStateActionCardProps) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        padding: '24px',
        border: `1px solid ${isActive ? colors.blue[500] : colors.grey[300]}`,
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backgroundColor: isActive ? colors.grey[100] : colors.white,
        flex: 1, // Equal width for cards in a row
        position: 'relative',
        '&:hover, &:active': {
          backgroundColor: colors.grey[100],
          borderColor: colors.blue[500],
        },
      }}
    >
      {showUpgradeTag && (
        <Box
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
          }}
        >
          {upgradeTag}
        </Box>
      )}
      <Stack alignItems="center" textAlign="center" gap={1}>
        <Stack p={0.5}>{icon}</Stack>

        <Stack alignItems="center" textAlign="center" gap={0.5}>
          <Typography
            variant="h4-medium"
            color={showUpgradeTag ? colors.grey[500] : colors.grey[900]}
          >
            {name}
          </Typography>

          <Typography variant="h5" color={showUpgradeTag ? colors.grey[500] : colors.grey[700]}>
            {description}
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};
